import { defineComponent as _defineComponent } from 'vue'
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import SvgAttention from "@/assets/icons/attention-symbol.svg";
import SvgClockPending from "@/assets/icons/clock-pending.svg";
import SvgCheck from "@/assets/icons/check.svg";
import { useRoute } from "vue-router/composables";
import { onBeforeMount, ref, watch } from "vue";
import { showServerError } from "@/utils";
import { updateQueryString } from "@/utils/updateQueryString";
import { useConversionSingle } from "@/services/TablePage/conversionReport";
import ConversionCards from "@/components_v3/statistics/ConversionCards.vue";
import ConversionChangeHistory from "@/components_v3/statistics/ConversionChangeHistory.vue";
import { getEmployeeConversions } from "@/api/conversions-report";
import { IConversion } from "@/api/types/conversions-report";
import BasePageTabs from "@/components-UI/BasePageTabs.vue";

type ConversionTab = typeof CONVERSION_TABS[keyof typeof CONVERSION_TABS];


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionSingle',
  setup(__props) {

const { getCards, fields } = useConversionSingle();
const route = useRoute();

const conversionID = ref(null);
const conversion = ref<IConversion>(null);
const cards = ref([]);
const isLoading = ref(true);

onBeforeMount(() => {
    conversionID.value = route.params.id;
    document.title = `Конверсия ${conversionID.value}`;

    getConversion();
    updateTabQueryOnLoad();
});

const getConversion = async () => {
    try {
        const { data } = await getEmployeeConversions({
            columns: fields,
            filters: [{ column: 'conversion_id', values: [conversionID.value] }],
        });
        conversion.value = data[0];
        cards.value = getCards(data[0]);
    } catch (err) {
        showServerError(err, 'Ошибка загрузки конверсии');
    } finally {
        isLoading.value = false;
    }
};

const CONVERSION_TABS = {
    MAIN: 'main',
    HISTORY: 'history',
} as const;

const TAB_VALUES: ConversionTab[] = [CONVERSION_TABS.MAIN, CONVERSION_TABS.HISTORY];

const isConversionTab = (v: string): v is ConversionTab => TAB_VALUES.includes(v as ConversionTab);

const currentTab = ref<ConversionTab>(CONVERSION_TABS.MAIN);

const tabs = ref([
    { text: 'Основное', value: CONVERSION_TABS.MAIN },
    { text: 'История изменений', value: CONVERSION_TABS.HISTORY },
]);

const changeTab = (value: string) => {
    const tab = isConversionTab(value) ? value : CONVERSION_TABS.MAIN;
    currentTab.value = tab;
    updateQueryString({ tab });
};

const updateTabQueryOnLoad = () => {
    const raw = route.query.tab;
    const q = Array.isArray(raw) ? raw[0] : raw;
    const tab = isConversionTab(q ?? '') ? q! : CONVERSION_TABS.MAIN;
    updateQueryString({ tab });
    currentTab.value = tab;
};

watch(
    () => route.query.tab,
    (raw) => {
        const q = Array.isArray(raw) ? raw[0] : raw;
        const tab = isConversionTab(q ?? '') ? q! : CONVERSION_TABS.MAIN;
        if (currentTab.value !== tab) {
            currentTab.value = tab;
        }
    },
);

return { __sfc: true,getCards, fields, route, conversionID, conversion, cards, isLoading, getConversion, CONVERSION_TABS, TAB_VALUES, isConversionTab, currentTab, tabs, changeTab, updateTabQueryOnLoad, PageLayout, SvgAttention, SvgClockPending, SvgCheck, ConversionCards, ConversionChangeHistory, BasePageTabs }
}

})